/* @flow */
import * as React from 'react';
import { create, update } from 'permissions/modelMasters';
import type { TypeComponent } from './types';
import ProductForm from '../forms/ProductForm/ProductForm';

const productRoutes: Array<*> = [
  {
    path: '/products/create',
    component: function createProduct(props: *): TypeComponent {
      return (
        <ProductForm
          mode="create"
          manufacturerID={props.location.state && props.location.state.manufacturerId}
          shortCode={props.location.state && props.location.state.shortCode}
        />
      );
    },
    exact: true,
    permissions: create,
  },
  {
    path: '/products/edit',
    component({ location }) {
      return (
        <ProductForm
          mode="edit"
          manufacturerID={
            location.state &&
            location.state.itemData &&
            location.state.itemData.owned_manufacturer_id
          }
          shortCode={
            location.state &&
            location.state.itemData &&
            location.state.itemData.manufacturer_short_code
          }
          itemData={location.state ? location.state.itemData : {}}
        />
      );
    },
    exact: true,
    permissions: update,
  },
];

export default productRoutes;
